//import auth from '@/plugins/auth'
//import $api from '@/api'

const user = {
    state: {
        userInfo: {
            userName: '',
        },
    },
    getters: {
        getUserInfo: state => {
            if (state.userInfo.userName === '') {
                let sUserInfo = JSON.parse(sessionStorage.getItem('userInfo'))
                if (sUserInfo != null) {
                    state.userInfo = sUserInfo
                }
            }
            return state.userInfo
        },
    },
    mutations: {
        SET_USER_INFO: (state, userInfo) => {
            delete userInfo.password
            sessionStorage.setItem('userInfo', JSON.stringify(userInfo))
            state.userInfo = {...userInfo }
        },
    },
    actions: {
    },
}

export default user